/**
 * Deterministischer Zufall.
 *
 * Der Zufallszustand ist Teil des Spielzustands, nicht globaler Nebeneffekt. Damit
 * laesst sich jede Partie aus Startzustand und Aktionsfolge exakt wiederholen - die
 * Voraussetzung fuer reproduzierbare Tests und fuer spaeteren Netzwerkbetrieb, bei
 * dem alle Beteiligten denselben Ablauf berechnen muessen.
 */

export interface Zufall {
  readonly zustand: number
}

export function zufallAus(saat: number): Zufall {
  // Null ist der einzige Fixpunkt von xorshift32 und muss vermieden werden.
  const z = saat >>> 0
  return { zustand: z === 0 ? 0x9e3779b9 : z }
}

function xorshift32(z: number): number {
  let x = z >>> 0
  x ^= x << 13
  x >>>= 0
  x ^= x >>> 17
  x ^= x << 5
  x >>>= 0
  return x
}

/** Naechste Ganzzahl von 0 bis `n - 1`, zusammen mit dem Folgezustand. */
export function naechste(r: Zufall, n: number): readonly [number, Zufall] {
  const z = xorshift32(r.zustand)
  return [z % n, { zustand: z }]
}

/** Standardwuerfel: 1 bis 6. */
export function wuerfel(r: Zufall): readonly [number, Zufall] {
  const [n, next] = naechste(r, 6)
  return [n + 1, next]
}

/** Seiten des Spezialwuerfels: dreimal Gruen, einmal Rot, einmal H, einmal 2. */
export type Bauwuerfel = 'gruen' | 'rot' | 'h' | 'doppelt'

const BAUWUERFEL_SEITEN: readonly Bauwuerfel[] = [
  'gruen',
  'gruen',
  'gruen',
  'rot',
  'h',
  'doppelt',
]

export function bauwuerfel(r: Zufall): readonly [Bauwuerfel, Zufall] {
  const [n, next] = naechste(r, 6)
  return [BAUWUERFEL_SEITEN[n]!, next]
}
